export default "https://cdn-static.gokick.com/assets/c9d0de51336abe1332e753a6383b3531473fb45b/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";